// extracted by mini-css-extract-plugin
export default {"loadingBody":"StandardPageLoading_loadingBody__yeLAz"};